"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  accountingMonitor: {
    my: '我的',
    draft: '草稿',
    submit: '提交',
    businessApprove: '业务审批中',
    localApprove: '本地财务审批中',
    fiApprove: '共享中心审批中',
    Approved: '付款审批通过',
    awaitPay: '等待付款',
    businessReject: '业务审批拒绝数',
    localReject: '本地财务审批拒绝数',
    fiReject: '共享中心审批拒绝',
    awaitAdjust: '等待调整收款信息数',
    processingInfo: '本地财务历史单据处理情况',
    processingInfoTip: '饼图表示付款申请单流转至本地财务后，单据处理情况',
    date: '日期：',
    to: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    processedSum: '单据处理总数',
    order: '单',
    day: '天',
    days: '天',
    over7Days: '超过7天',
    localFiProcess: '本地财务待处理单据情况',
    localFiProcessTip: '柱状图表示付款申请单流转至本地财务后，未处理单据的数量',
    localFiProcess2: '本地财务待处理单据情况(业务已审批)',
    localFiProcessTip2: '柱状图表示业务审批后流转至本地财务后，单位天数审批的付款申请单数量',
    mine: '我的',
    all: '全部',
    paidUnmarkedInvoice: '已付款未标记发票来齐定单数',
    paidUnmarkedInvoiceTip: '柱状图表示已付款申请单，未标记发票来齐的付款定单数',
    monthArray: '一个月,两个月,三个月,四个月,五个月,六个月,超过半年',
    overOneMonth: '一个月以上到期金额',
    inOneMonth: '一个月内到期金额',
    expired: '已过期',
    creditNoteStatistics: '优惠券统计',
    creditNoteStatisticsTip: '饼图表示当前优惠券未核销情况',
    creditNoteSum: '优惠券金额总数'
  }
};